export default __webpack_public_path__ + "static/media/ownExamHistory.d0420ef1.png";